import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'main-yoga': {
			// ?safe&mock-data&utm_source=FB&country=US&area=main-yoga&exp=web_yoga_printable_guide_welcome~1
			landing: {
				experiment: () =>
					import(
						/* webpackChunkName: "landing" */ '@/modules/Landing/instances/experiments/web_yoga_printable_guide_welcome'
					),
			},
		},
	},
]

export default config
